import apiCall from '../apiCall';

export function* submitInitialLoad(): Generator<any, any, any> {
  return yield* apiCall('admin/initialLoad', {
    method: 'POST',
  });
}
